import React from 'react';
import './Footer.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faYoutube, faInstagram } from '@fortawesome/free-brands-svg-icons';
import logo from '../ivydark.png';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { scrollToSection } from './Header';
import { Mail, Phone, Pin } from './Icons';

type FooterProps = { links: { id: string; text: string; to: string }[]; pages?: { to: string; text: string }[] };

export function Footer({ links, pages = [] }: FooterProps) {
  const year = new Date().getFullYear();
  const navigate = useNavigate();
  const location = useLocation();
  const onHome = location.pathname === '/';
  const go = (id: string, to: string) => (e: React.MouseEvent) => {
    e.preventDefault();
    if (onHome && document.getElementById(id)) scrollToSection(id);
    else {
      navigate(to);
      window.scrollTo({ top: 0 });
    }
  };
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__top">
          <div className="footer__brand">
            <img src={logo} alt="Ivy League Painting Ltd." />
            <p>
              Full-service painting company serving homes, strata buildings, commercial spaces and warehouses
              across Delta and the Lower Mainland. Licensed, $5M insured and BBB A+ accredited.
            </p>
            <div className="footer__social">
              <a href="https://www.instagram.com/ivyleaguepainting/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <FontAwesomeIcon icon={faInstagram} />
              </a>
              <a href="https://www.facebook.com/ivyleaguepaintingltd/" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <FontAwesomeIcon icon={faFacebookF} />
              </a>
              <a href="https://www.youtube.com/@IvyLeaguePaintingLtd" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
                <FontAwesomeIcon icon={faYoutube} />
              </a>
            </div>
          </div>

          <nav className="footer__nav" aria-label="Footer">
            <span className="footer__label">Explore</span>
            {links.map((l) => (
              <a key={l.id} href={l.to} onClick={go(l.id, l.to)}>
                {l.text}
              </a>
            ))}
            {pages.map((p) => (
              <Link key={p.to} to={p.to}>
                {p.text}
              </Link>
            ))}
          </nav>

          <div className="footer__contacts">
            <span className="footer__label">Contacts</span>
            <a href="tel:+16043655225">
              <Phone /> +1 (604) 365-5225
            </a>
            <a href="mailto:ivyleaguepaint@gmail.com">
              <Mail /> ivyleaguepaint@gmail.com
            </a>
            <span>
              <Pin /> 1215C 56 St, Delta, BC V4L 2A6
            </span>
            <a
              className="footer__bbb"
              href="https://www.bbb.org/ca/bc/delta/profile/painting-contractors/ivy-league-painting-ltd-0037-1372336/#sealclick"
              target="_blank"
              rel="nofollow noopener noreferrer"
            >
              <img src="/imgs/bbbseal.png" alt="BBB Accredited Business, A+ rating" />
            </a>
          </div>
        </div>

        <div className="footer__bottom">
          <span>© {year} Ivy League Painting Ltd.</span>
          <span>All rights reserved.</span>
        </div>
      </div>
    </footer>
  );
}
